export const reservationLeadTimeData = [
	{ leadTime: 'Same day', reservations: 20 },
	{ leadTime: '1-3 days', reservations: 50 },
	{ leadTime: '4-7 days', reservations: 30 },
	{ leadTime: 'Over 1 week', reservations: 15 },
]
